module.exports = __webpack_public_path__ + "static/media/gamingImage.3bbd922c.png";